import { Link } from "react-router-dom";

import { ChevronRightIcon } from "../../../constants/icon_path";

const ProfileMenuItem = ({ to, MenuIcon, title, showHr = true }) => {
  return (
    <div>
      <Link to={to}>
        <div className="page-link d-flex justify-content-between">
          <div className="d-flex">
            <MenuIcon size={25} className="profile-icon" color="grey" />
            <p className="link-title">{title}</p>
          </div>
          <ChevronRightIcon color="grey" className="arrow-icon" size={15} />
        </div>
      </Link>
      {showHr && <hr />}
    </div>
  );
};

export default ProfileMenuItem;
